export default __webpack_public_path__ + "static/media/EmilyWebb.52112db7.jpg";